import React from "react";
import { Grid, Typography, Rating, Button, Link, Stack } from "@mui/material";
import brokenImg from "../Asset/images/broken-images.png";
import { stripHtml } from "./utility";

function CategoriesFull(props) {
  const {
    name,
    logo_full_path,
    id,
    description,
    ratings,
    company_name,
    product_category,
  } = props.data;
  const { type } = props;
  const desc = stripHtml(description.slice(0, 25));
  return (
    <Grid container sx={{ color: "#5a5a56" }}>
      <Grid item xs={12} container style={{ padding: "10px" }}>
        <Grid item xs={4} lg={2} sx={{ pr: "20px" }}>
          <img
            src={logo_full_path || brokenImg}
            alt={name}
            style={{ width: "100%", borderRadius: "10px" }}
          />
        </Grid>
        <Grid item xs={8} lg={6} textAlign={"left"}>
          <Stack direction="column" spacing={0}>
            <Typography variant="h7" sx={{ fontWeight: "bold", pb: "15px" }}>
              {name}
            </Typography>
            <Typography variant="body1">
              {type === "category" ? name : product_category.name}
            </Typography>
            <Typography variant="body1">{company_name}</Typography>
            <Typography varian="body2">{desc}...</Typography>
            <Rating value={parseInt(ratings)} readOnly sx={{ pt: "10px" }} />
          </Stack>
        </Grid>
        <Grid item xs={12} lg={2} sx={{ mt: "15px" }}>
          <Link href={`/detail/${id}`}>
            <Button
              fullWidth
              variant="contained"
              sx={{
                borderRadius: "30px",
                background: "#228B22",
                fontSize: 11,
              }}
            >
              View More
            </Button>
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default CategoriesFull;
